import React from 'react';
import { Modal } from 'react-bootstrap';
import {
    Button,
    Checkbox,
    FormControlLabel
} from '@sumologic/yama-ds-components';
import { PropTypes } from 'prop-types';
import Translate from '../../components/Translate/Translate';

function ModalFooter({
    formProps,
    actionFields,
    onSubmit,
    resources,
    fromContextualMenu,
    chooseTabData
}) {
    let disabled = false;

    actionFields.forEach(field => {
        if (
            (field.isRequired || field.required) &&
            (!field.value || field.value === '')
        ) {
            disabled = true;
        }
    });
    if (!formProps.values.action) {
        disabled = true;
    } else if (resources.length && !formProps.values.resource) {
        disabled = true;
    } else if (actionFields.length && !!Object.keys(formProps.errors).length) {
        disabled = true;
    }
    return (
        <Modal.Footer className={'run-action-footer'}>
            {fromContextualMenu ? (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={chooseTabData.openResultInOtherTab}
                            onChange={event => {
                                const checked = event.target.checked;
                                const numericChecked = checked ? '1' : '0';
                                chooseTabData.setOpenResultInOtherTab(checked);
                                //RN: set value in the localStorage to reuse the last value
                                localStorage.setItem(
                                    'openResultInOtherTab',
                                    numericChecked
                                );
                            }}
                            inputProps={{ id: 'choose-tab' }}
                        />
                    }
                    label={<Translate message="Open results in a new tab" />}
                />
            ) : (
                <div />
            )}
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    onSubmit();
                }}
                disabled={disabled}
            >
                <Translate message="Run action" />
            </Button>
        </Modal.Footer>
    );
}

ModalFooter.propTypes = {
    formProps: PropTypes.object.isRequired,
    actionFields: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    resources: PropTypes.array.isRequired,
    fromContextualMenu: PropTypes.bool,
    chooseTabData: PropTypes.object
};

export default ModalFooter;
